/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Author M. Atoar Rahman
 * Title: Drug Category DataTable
 * Description: Master Setup of Drug Category DataTable
 * Date: 15/03/2022
 */

import React, { useCallback, useEffect } from 'react';
import { Badge, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import useDataTable from '../../../hooks/useDataTable';
import SweetAlertService from '../../../services/SweetAlertService';
import UrlService from '../../../services/UrlService';
import { useDrugCategory } from './ContextAPI';
import FormInfo from './FormInfo';

export default function DataTable() {
    const { data, getAllData } = useDrugCategory();
    const { deleteSwal } = SweetAlertService();

    const dataList = useCallback(() => {
        getAllData();
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    const deleteHandler = (row) => {
        deleteSwal({
            id: row.id,
            url: UrlService.deleteDrugCategoryUrl(),
            refreshList: getAllData,
            beforeTitle: 'Are you sure?',
            beforeText: "You won't be able to revert this!",
            afterTitle: 'Deleted!',
            afterText: 'Your file has been deleted.',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
    };

    const columns = [
        {
            name: 'SL',
            selector: (row) => row.serial,
            width: '50px',
        },
        {
            name: 'Name',
            selector: (row) => row.name,
            sortable: true,
            grow: 3,
        },
        {
            name: 'Status',
            selector: (row) => row.status,
            cell: (row) =>
                row.status == 1 ? (
                    <Badge className="badgeActive" bg="success">
                        Active
                    </Badge>
                ) : (
                    <Badge className="badgeInactive" bg="success">
                        Inactive
                    </Badge>
                ),
        },
        {
            name: 'Action',
            selector: (row) => row.action,
            cell: (row) => (
                <>
                    {/* Off By shariful Hasan 07/06/2022
                     <button data-id={row.id} type="button" className="btn btn-light actionBtn">
                        {layout}
                    </button> */}

                    <FormInfo editData={row} />

                    <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-del-drugcategory-${row.id}`}>Delete</Tooltip>}>
                        <Button
                            onClick={() => {
                                deleteHandler(row);
                            }}
                            type="button"
                            className="btn btn-light actionBtn"
                        >
                            <i className="fas fa-trash-alt" />
                        </Button>
                    </OverlayTrigger>
                </>
            ),
        },
    ];

    const search_column = { name: 'Name' };
    return useDataTable({ columns, data, search_column });
}
